import { render, staticRenderFns } from "./tpl-4.vue?vue&type=template&id=29446b0e&scoped=true&"
import script from "./tpl-4.vue?vue&type=script&lang=js&"
export * from "./tpl-4.vue?vue&type=script&lang=js&"
import style0 from "./tpl-4.vue?vue&type=style&index=0&id=29446b0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29446b0e",
  null
  
)

export default component.exports